import { createSlice,PayloadAction } from '@reduxjs/toolkit';


interface clientDetails {
    activeClient:object,
    insertData:any,
  }
const initialState: clientDetails = {  
    activeClient:{},
    insertData:[],
};
export const clientDetails = createSlice({
  name: 'clientDetails',
  initialState: initialState,
  reducers: {
     
      setActiveClient: (state,action: PayloadAction<any>) => { 
        state.activeClient=action.payload;
      },


    }
});

// this is for dispatch
export const { setActiveClient} = clientDetails.actions;

// this is for configureStore
export default clientDetails.reducer;